module.exports = __webpack_public_path__ + "img/ic_fitnessplan_notes.d16c8e91.svg";